import React, { useEffect, useState } from "react";
import { Receipt } from "lucide-react";
import { api, fmtPrice } from "../../lib/api";

export const OrdersPanel = () => {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).catch(() => setOrders({ count: 0, total_revenue: 0, orders: [] }));
  }, []);

  return (
    <div data-testid="orders-panel">
      <div className="flex flex-wrap items-center gap-x-8 gap-y-2 mb-6">
        <div className="flex items-center gap-2">
          <Receipt className="w-4 h-4" strokeWidth={1.5} />
          <p className="label" data-testid="orders-count">
            {orders === null ? "Loading…" : `${orders.count} paid order${orders.count === 1 ? "" : "s"}`}
          </p>
        </div>
        {orders !== null && (
          <p className="label text-[#8A8F99]" data-testid="orders-revenue">Total: {fmtPrice(orders.total_revenue)}</p>
        )}
      </div>
      {orders !== null && orders.count === 0 && (
        <p className="text-[#3A4150]" data-testid="orders-empty">No paid orders yet. They'll show up here the moment someone checks out.</p>
      )}
      {orders !== null && orders.count > 0 && (
        <div className="border border-[#D4D7DD] divide-y divide-[#D4D7DD]">
            {orders.orders.map((o) => (
                  <div key={o.session_id} data-testid="order-row" className="flex flex-col sm:flex-row sm:justify-between gap-3 px-5 py-4 bg-[#EDEEF1]">
                    <div>
                      <p className="text-sm">
                        {o.lines.map((l, i) => (
                          <span key={`${l.name}-${l.size || "OS"}-${i}`}>{i > 0 && " · "}{l.name}{l.size ? ` (${l.size})` : ""}{l.quantity > 1 ? ` ×${l.quantity}` : ""}</span>
                        ))}
                      </p>
                      {(o.customer_name || o.customer_email) && (
                        <p className="text-sm mt-1.5" data-testid="order-customer">
                          {o.customer_name}{o.customer_name && o.customer_email ? " · " : ""}
                          {o.customer_email && <span className="text-[#3A4150]">{o.customer_email}</span>}
                        </p>
                      )}
                      {o.shipping && (
                        <p className="text-sm text-[#3A4150] mt-0.5" data-testid="order-shipping">
                          {[o.shipping.name !== o.customer_name ? o.shipping.name : null, o.shipping.line1, o.shipping.line2,
                            [o.shipping.city, o.shipping.state].filter(Boolean).join(", "), o.shipping.postal_code]
                            .filter(Boolean).join(", ")}
                        </p>
                      )}
                      <p className="label text-[#8A8F99] mt-1.5">{o.created_at ? new Date(o.created_at).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : ""}</p>
                    </div>
                    <span className="text-sm font-medium shrink-0">{fmtPrice(o.amount || 0)}</span>
                  </div>
          ))}
        </div>
      )}
    </div>
  );
};
